import axios from '../../../axios'

// 列表
export const list = (data) => {
  return axios({
    url: 'plan/monthlyPlan/list',
    method: 'post',
    data
  })
}
// 详细视图列表
export const detailList = (data) => {
  return axios({
    url: 'plan/monthlyPlan/detailList',
    method: 'post',
    data
  })
}
// 编辑
export const edit = (data) => {
  return axios({
    url: 'plan/monthlyPlan/edit',
    method: 'post',
    data
  })
}
// 保存
export const save = (data) => {
  return axios({
    url: 'plan/monthlyPlan/save',
    method: 'post',
    data
  })
}
// 查看
export const view = (data) => {
  return axios({
    url: 'plan/monthlyPlan/view',
    method: 'post',
    data
  })
}
// 删除
export const batchDelete = (data) => {
  return axios({
    url: 'plan/monthlyPlan/delete',
    method: 'post',
    data
  })
}


// 所有计划
export const allPlan = (data) => {
  return axios({
    url: 'plan/monthlyPlan/allPlan',
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/http/moudules/biz/plan/monthlyPlan.js